import type { ICellRendererParams } from 'ag-grid-community';
import type { NewsArticle } from '../../schema';

export function SlugCell(p: ICellRendererParams<NewsArticle, string>) {
  if (!p.value) return null;
  return (
    <code className="rounded bg-surface-muted px-2 py-1 font-mono text-[12px] text-foreground-muted">
      {p.value}
    </code>
  );
}
